import Vue from 'vue';
import { INJECT_UICORE_BUS, INJECT_UICORE_COMPONENT_HOST } from "../../../lib/utils/consts";
import { UcSlot } from './UcSlot';
import { UcScopedSlot } from './UcScopedSlot';
import { vueMakeExtendFactory } from "../../../lib/utils/vue/vueMakeExtendFactory";
import { observeInDesigner } from './observeInDesigner';
const PatchedVueComponentBase = Vue.extend({
  ucIsPatchedComponent: true,
  components: {
    // 要注入的组件列表
    UcSlot,
    UcScopedSlot
  },
  inject: {
    [INJECT_UICORE_BUS]: {
      from: INJECT_UICORE_BUS,
      default: null
    }
  },
  methods: {
    ucObserveInDesigner: observeInDesigner
  },
  provide() {
    return {
      [INJECT_UICORE_COMPONENT_HOST]: this
    };
  },
  render: h => h() // 如果遇到逻辑型的组件，那么他们大概率是没有 render 方法的，需要帮忙补充一个
});
export const getPatchedVueComponent = vueMakeExtendFactory(PatchedVueComponentBase, {
  excludeOptions(options) {
    return !!options.ucIsPatchedComponent;
  }
});